export const layoutSettings = titleTemplate => ({
        logo: null,
        socialLinks: [],
        footerMenu: [],
        script: null,
        head: {
            meta: [],
            titleTemplate,
        },
    }),
    homePageSettings = () => ({
        searchFormBackgrounds: {},
        topBlock: null,
        bottomBlock: null,
    })
